import React from "react";
import { DateFilters } from "../../../../../components/ui/Form/Period";
import _Button from "../../../../../components/generic/_Button";
import DataReportByCustomers from "./DataReportByCustomers";
import { useRCSReportByCustomers } from "../hooks/useRCSReportByCustomers";

const ReportByCustomers = () => {
  const { formik, isLoading, _validate, handleReset, data } =
    useRCSReportByCustomers();
  return (
    <div className="flex flex-col">
      <div className="bg-white rounded-lg p-3">
        <div className="w-full">
          <DateFilters
            required
            setFilterFrom={(e) => formik.setFieldValue("period.dateFrom", e)}
            setFilterTo={(e) => formik.setFieldValue("period.dateTo", e)}
            errors={formik.errors}
            isClean={formik.values.period.dateFrom === ""}
          />
        </div>
        <div className="gap-2 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2">
          <_Button
            icon="clear_all"
            onClick={handleReset}
            disabled={isLoading}
            loading={isLoading}
            style="none"
            title="Limpiar"
            className="w-full"
          />
          <_Button
            icon="analytics"
            style="primary"
            onClick={async () => await _validate()}
            title="Generar Reporte"
            className="w-full"
          />
        </div>
      </div>
      <DataReportByCustomers data={data} isLoading={isLoading} />
    </div>
  );
};

export default ReportByCustomers;
